import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { ServiceContentState } from './types';

export const INITIAL_STATE: ServiceContentState = {
  content: null,
  getServiceContent: {
    status: null,
    error: null,
  },
};

const getServiceContentRequestHandler = (state: ServiceContentState): ServiceContentState => ({
  ...state,
  getServiceContent: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const getServiceContentSuccessHandler = (
  state: ServiceContentState,
  { payload }: ActionType<typeof actions.getServiceContent.success>,
): ServiceContentState => ({
  ...state,
  content: payload,
  getServiceContent: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const getServiceContentFailureHandler = (
  state: ServiceContentState,
  { payload }: ActionType<typeof actions.getServiceContent.failure>,
): ServiceContentState => ({
  ...state,
  getServiceContent: {
    error: payload.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

const ServiceContentReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.getServiceContent.request, getServiceContentRequestHandler)
  .handleAction(actions.getServiceContent.success, getServiceContentSuccessHandler)
  .handleAction(actions.getServiceContent.failure, getServiceContentFailureHandler);

export default ServiceContentReducer;
